import createIcon from '../../createIcon';

/**
 * @component @name LocalPhone
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi42MiAxMC43OUM4LjA2IDEzLjYyIDEwLjM4IDE1LjkzIDEzLjIxIDE3LjM4TDE1LjQxIDE1LjE4QzE1LjY4IDE0LjkxIDE2LjA4IDE0LjgyIDE2LjQzIDE0Ljk0QzE3LjU1IDE1LjMxIDE4Ljc2IDE1LjUxIDIwIDE1LjUxQzIwLjU1IDE1LjUxIDIxIDE1Ljk2IDIxIDE2LjUxVjIwQzIxIDIwLjU1IDIwLjU1IDIxIDIwIDIxQzEwLjYxIDIxIDMgMTMuMzkgMyA0QzMgMy40NSAzLjQ1IDMgNCAzSDcuNUM4LjA1IDMgOC41IDMuNDUgOC41IDRDOC41IDUuMjUgOC43IDYuNDUgOS4wNyA3LjU3QzkuMTggNy45MiA5LjEgOC4zMSA4LjgyIDguNTlMNi42MiAxMC43OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalPhone = createIcon('LocalPhone', [
  [
    'path',
    {
      d: 'M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z',
      key: '11fadt',
    },
  ],
]);

export default LocalPhone;
